<template>
  <PaymentReceiptDetailTabDetail
    v-if="activeTab === 'detail'"
    :payment-receipt="paymentReceipt"
  />

  <PaymentReceiptDetailTabShipping
    v-else-if="activeTab === 'shipping'"
    :payment-receipt="paymentReceipt"
  />

  <PaymentReceiptDetailTabDocuments
    v-else-if="activeTab === 'documents'"
    :payment-receipt="paymentReceipt"
  />

  <PaymentReceiptDetailTabHistory
    v-else-if="activeTab === 'history'"
    :payment-receipt="paymentReceipt"
  />

  <PaymentReceiptDetailTabDetail
    v-else
    :payment-receipt="paymentReceipt"
  />
</template>

<script>
import PaymentReceiptDetailTabDetail from '@/components/paymentReceipts/detail/tabs/PaymentReceiptDetailTabDetail.vue';
import PaymentReceiptDetailTabShipping from '@/components/paymentReceipts/detail/tabs/PaymentReceiptDetailTabShipping.vue';
import PaymentReceiptDetailTabDocuments from '@/components/paymentReceipts/detail/tabs/PaymentReceiptDetailTabDocuments.vue';
import PaymentReceiptDetailTabHistory from '@/components/paymentReceipts/detail/tabs/PaymentReceiptDetailTabHistory.vue';

export default {
  name: 'PaymentReceiptDetailTabsPanel',
  components: {
    PaymentReceiptDetailTabDetail,
    PaymentReceiptDetailTabShipping,
    PaymentReceiptDetailTabDocuments,
    PaymentReceiptDetailTabHistory,
  },
  props: {
    activeTab: {
      type: String,
      required: true,
    },
    paymentReceipt: {
      type: Object,
      default: null,
    },
  },
};
</script>
